import { observable, action, runInAction } from 'mobx'
import posterApi from '@api/poster'
import { getObjValue, getCookie, setCookie } from '@hlj/hlj-utils'

class Store {
  @observable poster = false
  @observable image_path = ''
  @observable postersId = ''
  @observable target_url = ''

  @action
  getPoster = async () => {
    let { data } = await posterApi.poster(3202)
    runInAction(() => {
      let holes = getObjValue(
        data,
        'floors.SITE_FLOOR_LOCAL_SUB_MERDHANT_POPUP.holes'
      )
      if (holes) {
        this.image_path = getObjValue(holes[0], 'posters.image_path')
        this.postersId = getObjValue(holes[0], 'posters.id')
        this.target_url = getObjValue(holes[0], 'posters.target_url')

        this.doCookieCheck()
      }
    })
  }

  @action
  doCookieCheck = () => {
    const { postersId } = this
    const cookiePoster = getCookie('cookie' + postersId) || 0
    if (cookiePoster) {
      this.poster = false
    } else {
      this.poster = true
    }
  }

  @action
  hidePoster = () => {
    this.poster = false
  }

  @action
  hidePostertoLink = async () => {
    const { postersId, target_url } = this

    this.poster = false
    setCookie('cookie' + postersId, 1, 360)
    window.location.href = target_url
  }
}
export default new Store()
